"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _flow = _interopRequireDefault(require("lodash/fp/flow"));

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _identity = _interopRequireDefault(require("lodash/identity"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _everpolate = _interopRequireDefault(require("everpolate"));

var _Context = require("./Context");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _clamp = function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
};

var getMarkerBounds = function getMarkerBounds(outputRange, prevMarker) {
  return {
    left: prevMarker ? prevMarker.position : 0,
    right: outputRange[1],
    clamp: function clamp(value) {
      return _clamp(value, this.left, this.right);
    }
  };
};

var updateMarkerBounds = function updateMarkerBounds(outputRange, marker, prevMarker) {
  marker.bounds = getMarkerBounds(outputRange, prevMarker);

  if (prevMarker) {
    prevMarker.bounds.right = Math.min(marker.position, outputRange[1]);
  }
};

var interpolatePosition = function interpolatePosition(inputRange, outputRange) {
  return function (position) {
    return _everpolate["default"].linear(position, inputRange, outputRange)[0];
  };
};

var _default = function _default(_ref) {
  var MarkerHandler = _ref.MarkerHandler,
      Marker = _ref.Marker,
      SliderTrack = _ref.SliderTrack,
      getDerivedState = _ref.getDerivedState,
      _ref$getInitialMarker = _ref.getInitialMarkerState,
      getInitialMarkerState = _ref$getInitialMarker === void 0 ? function () {
    return {};
  } : _ref$getInitialMarker;
  return function (Target) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_PureComponent) {
      _inherits(_class, _PureComponent);

      function _class() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_class)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "state", _this._getInitialState());

        _defineProperty(_assertThisInitialized(_this), "_onChangeCallback", function () {
          var onChange = _this.props.onChange;
          if (!onChange) return;
          var markers = _this.state.markers;
          var markerValues = markers.reduce(function (values, _ref2) {
            var key = _ref2.key,
                state = _ref2.state;
            return _objectSpread({}, values, _defineProperty({}, key, state.value));
          }, {});
          onChange(markerValues);
        });

        _defineProperty(_assertThisInitialized(_this), "_updateBounds", function () {
          _this.setState(function (_ref3) {
            var markers = _ref3.markers,
                layout = _ref3.layout;
            return {
              markers: markers.reduce(function (result, marker, index) {
                var nextMarker = _objectSpread({}, marker, {
                  state: _objectSpread({}, marker.state, {
                    position: _this._getPositionFromValue(marker.state.value)
                  })
                });

                updateMarkerBounds([0, layout.width], nextMarker.state, index > 0 ? result[index - 1].state : undefined);
                result.push(nextMarker);
                return result;
              }, [])
            };
          });
        });

        _defineProperty(_assertThisInitialized(_this), "onSlide", (0, _throttle["default"])(function (index, position) {
          if (_this.state.markers[index].position === position) return;

          _this.setState(function (_ref4) {
            var markers = _ref4.markers;

            var nextMarkers = _toConsumableArray(markers);

            nextMarkers[index] = _objectSpread({}, markers[index], {
              state: _objectSpread({}, markers[index].state, {
                position: position,
                value: _this._getValueFromPosition(position)
              })
            });
            return {
              markers: nextMarkers
            };
          }, _this._onChangeCallback);
        }, _this.props.slideEventThrottle, {
          leading: false,
          trailing: true
        }));

        _defineProperty(_assertThisInitialized(_this), "onSlideStop", function () {
          _this.onSlide.flush();

          _this._updateBounds();
        });

        _defineProperty(_assertThisInitialized(_this), "onLayout", (0, _throttle["default"])(function (layout) {
          var markers = _this.state.markers || _this._getInitialMarkerState(layout);

          _this.setState({
            layout: layout,
            markers: markers
          });
        }, _this.props.layoutEventThrottle, {
          leading: true,
          trailing: true
        }));

        _defineProperty(_assertThisInitialized(_this), "renderMarker", function (_ref5) {
          var key = _ref5.key,
              index = _ref5.index,
              element = _ref5.element,
              state = _ref5.state;
          return _react["default"].createElement(MarkerHandler, _extends({}, state, {
            disabled: state.bounds.left == state.bounds.right,
            key: key,
            index: index,
            name: key,
            onSlide: _this.onSlide,
            onSlideStop: _this.onSlideStop,
            sliderLayout: _this.state.layout
          }), element);
        });

        return _this;
      }

      _createClass(_class, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
          if (prevProps.children && this.props.children && prevProps.children.length !== this.props.children.length) throw new Error('Changing Slider children on the fly is not supported.');
          if (prevState.layout && prevState.layout.width !== this.state.layout.width) this._updateBounds();
          if (this.state.layout && prevProps.value !== this.props.value) this._updateMarkerValues();
        }
      }, {
        key: "_getInitialState",
        value: function _getInitialState() {
          var width = this.props.width;
          var layout = Number(width) === width ? {
            width: width
          } : undefined;
          var markers = layout ? this._getInitialMarkerState(layout) : undefined;
          return {
            layout: layout,
            markers: markers
          };
        }
      }, {
        key: "_getInitialMarkerState",
        value: function _getInitialMarkerState(layout) {
          var _this2 = this;

          var initialValue = this.props.value || this.props.initialValue;
          var outputRange = this.props.range || [0, 1];
          var layoutRange = [0, layout.width];
          var getPosition = interpolatePosition(outputRange, layoutRange);

          var getInitialValue = function getInitialValue(key) {
            if (!isNaN(initialValue)) return initialValue || 0;
            if (!(key in initialValue)) throw new Error("Undefined initial value for slider marker \"".concat(key, "\"."));
            return initialValue[key];
          };

          var markers = [];

          _react["default"].Children.forEach(this.props.children, function (element, index) {
            if (!_react["default"].isValidElement(element)) return;
            var key = element.props.name || index;

            var value = _clamp.apply(void 0, [getInitialValue(key)].concat(_toConsumableArray(outputRange)));

            var state = {
              value: value,
              position: getPosition(value),
              layout: _this2._getMarkerLayout({
                index: index,
                key: key,
                element: element
              })
            };
            updateMarkerBounds(layoutRange, state, index > 0 ? markers[index - 1].state : undefined);
            Object.assign(state, getInitialMarkerState(state));
            var marker = {
              key: key,
              index: index,
              element: element,
              state: state
            };
            markers.push(marker);
          });

          return markers;
        }
      }, {
        key: "_updateMarkerValues",
        value: function _updateMarkerValues() {
          var value = this.props.value;
          var layout = this.state.layout;
          var outputRange = this.props.range || [0, 1];
          var layoutRange = [0, layout.width];
          var getPosition = interpolatePosition(outputRange, layoutRange);

          var getValue = function getValue(key) {
            if (!isNaN(value)) return value || 0;
            if (!(key in value)) throw new Error("Undefined value for slider marker \"".concat(key, "\"."));
            return value[key];
          };

          this.setState(function (_ref6) {
            var markers = _ref6.markers,
                layout = _ref6.layout;
            return {
              markers: markers.map(function (marker) {
                var nextMarker = _objectSpread({}, marker);

                var value = _clamp.apply(void 0, [getValue(marker.key)].concat(_toConsumableArray(outputRange)));

                nextMarker.state = _objectSpread({}, marker.state, {
                  value: value,
                  position: _clamp(getPosition(value), 0, layout.width)
                });
                return nextMarker;
              })
            };
          }, this._updateBounds);
        }
      }, {
        key: "_getMarkerLayout",
        value: function _getMarkerLayout(data) {
          var getMarkerLayout = this.props.getMarkerLayout;
          if (getMarkerLayout) return getMarkerLayout(data);else if (_react["default"].isValidElement(data.element) && data.element.type === Marker) {
            var size = data.element.props.size;
            return {
              width: size,
              height: size
            };
          }
          return undefined;
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              trackProps = _this$props.trackProps,
              props = _objectWithoutProperties(_this$props, ["trackProps"]);

          var markers = this.state.markers;
          return _react["default"].createElement(_Context.Provider, {
            value: this.state
          }, _react["default"].createElement(Target, _extends({
            onLayout: this.onLayout
          }, props), markers && markers.map(this.renderMarker), _react["default"].createElement(SliderTrack, {
            trackProps: trackProps
          })));
        }
      }, {
        key: "_getValueFromPosition",
        get: function get() {
          if (!this.state.layout || !this.props.range) return _identity["default"];
          return (0, _flow["default"])(interpolatePosition([0, this.state.layout.width], this.props.range), this.props.formatValue);
        }
      }, {
        key: "_getPositionFromValue",
        get: function get() {
          var _this3 = this;

          if (!this.state.layout || !this.props.range) return _identity["default"];
          return (0, _flow["default"])(interpolatePosition(this.props.range, [0, this.state.layout.width]), function (pos) {
            return _clamp(pos, 0, _this3.state.layout.width);
          });
        }
      }]);

      return _class;
    }(_react.PureComponent), _defineProperty(_class, "displayName", "Slider(".concat(Target.displayName || Target.name, ")")), _defineProperty(_class, "defaultProps", Object.assign({
      formatValue: _identity["default"],
      initialValue: 0,
      minDistance: 1,
      slideEventThrottle: 50,
      layoutEventThrottle: 50
    }, Target.defaultProps || {})), _defineProperty(_class, "propTypes", _objectSpread({
      width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
      initialValue: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array, _propTypes["default"].object]).isRequired,
      value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array, _propTypes["default"].object]).isRequired,
      formatValue: _propTypes["default"].func,
      getMarkerLayout: _propTypes["default"].func,
      minDistance: _propTypes["default"].number.isRequired,
      slideEventThrottle: _propTypes["default"].number.isRequired,
      layoutEventThrottle: _propTypes["default"].number.isRequired
    }, Target.propTypes || {})), _defineProperty(_class, "getDerivedStateFromProps", getDerivedState), _temp;
  };
};

exports["default"] = _default;